<ion-app [class]="sessionService.getTheme()">
  <!-- <ion-split-pane contentId="main-content"> -->
  <ion-menu contentId="main-content" type="overlay">
    <ion-content class="cus-menu-content" id="htmenu">
      <!-- <div id="bookmarks-menu">favs</div> -->
      <ion-list class="list-content">
        <ion-menu-toggle auto-hide="true">
          <!-- <div *ngFor="let page of pages">
            <ion-item [routerDirection]="'forward'" [routerLink]="[page.url]" lines="none" class="nav-content">
              <ion-label>
                {{page.title}}
              </ion-label>
            </ion-item>
          </div> -->

          <ion-item lines="none" class="nav-content">
            <ion-label>

            </ion-label>
          </ion-item>

          <app-client-side-menu
            *ngIf="sessionService.user?.permessions === 'CLIENT'"
          ></app-client-side-menu>
          <app-administrator-side-menu
            *ngIf="sessionService.user?.permessions !== 'CLIENT'"
          ></app-administrator-side-menu>

          <div
            *ngIf="sessionService.getBookmarks().length > 0"
            id="bookmarks-menu"
          >
            <b style="font-size: 0.9em; text-transform: uppercase"
              >I miei segnalibri:</b
            >
            <br />
            <br />

            <div
              *ngFor="let bm of sessionService.getBookmarks()"
              (click)="onBookmarkClick(bm.url)"
              id="bookmarks-links"
            >
              <div class="bookmark-link">
                {{ bm.title }}
                <ion-icon
                  name="close"
                  (click)="removeBookmark(bm.url)"
                ></ion-icon>
              </div>
            </div>
          </div>

        </ion-menu-toggle>

        <!-- @todo other pages -->


      </ion-list>

    </ion-content>
    <ion-footer class="htfooter" (click)="closeMenu()">
      <amplify-authenticator  >
        <ng-template
                amplifySlot="authenticated"
                let-user="user"
                let-signOut="signOut"
        >
          <ion-button color="primary" (click)="signOut()">Esci</ion-button>
        </ng-template>
      </amplify-authenticator>
    </ion-footer>
  </ion-menu>

  <!-- <div id="add-to-bookmarks" (click)="addToBookmarks()">
    <ion-icon name="bookmark"></ion-icon>
  </div> -->

  <ion-router-outlet id="main-content"></ion-router-outlet>
  <!-- </ion-split-pane> -->
</ion-app>
